// activity 기록용 changed_fields 판정 — **의존성 zero 로 유지할 것**
// (extensionBridge.js 와 같은 이유: 무거운 모듈을 끌고 들어가면 import 하는 테스트가 전부 오염된다)
//
// 왜 프론트가 판정하나: 암호화 항목은 저장할 때마다 IV 가 재생성돼 같은 값을 재저장해도
// 암호문이 달라진다. 서버는 DB 값과 비교할 수 없으므로, 암호화 전 평문을 아는 프론트가
// 변경된 "필드 타입" 목록만 서버에 알려준다 (값·라벨은 보내지 않는다 — OP-114 정책 선상).

// 커스텀 필드는 라벨이 민감할 수 있어 타입도 'custom' 으로 뭉뚱그린다 (서버 화이트리스트와 합의된 값)
export const getActivityFieldType = (field) => (field?.custom === true ? 'custom' : field?.type)

const isEmpty = (value) => value == null || value.length === 0

// fieldManager.checkChanged 의 isEqual 과 동일 기준 — 저장 버튼 활성 판정과 어긋나면
// "안 바꿨는데 변경 기록" / "바꿨는데 기록 없음" 이 생긴다
const isEqualLoose = (a, b) => {
  if (isEmpty(a) === true && isEmpty(b) === true) {
    return true
  }
  return a === b
}

export const computeChangedFields = ({
  initBasicFields = [],
  initCustomFields = [],
  basicFields = [],
  customFields = [],
  initValues = {},
  values = {},
}) => {
  const changed = new Set()

  if (isEqualLoose(initValues.requiredTitle, values.requiredTitle) === false) {
    changed.add('title')
  }

  const initFields = [...initBasicFields, ...initCustomFields]
  const currentFields = [...basicFields, ...customFields]
  const currentIds = new Set(currentFields.map((field) => field.id))

  // 삭제된 항목 — 로드 시점엔 있었는데 현재 폼엔 없음
  initFields.forEach((field) => {
    if (currentIds.has(field.id) === false) {
      changed.add(getActivityFieldType(field))
    }
  })

  currentFields.forEach((field) => {
    const type = getActivityFieldType(field)

    // 신규 추가 항목 (저장 payload 에 id 가 빠지는 항목)
    if (field.isNew === true) {
      changed.add(type)
      return
    }

    // 커스텀 필드 라벨 변경 (checkChanged 와 동일 판정)
    if (field.custom === true && field.newLabel != null && field.newLabel !== field.label) {
      changed.add('custom')
      return
    }

    // 파일: 파일 id 목록 비교 (checkChanged 와 동일 판정 — content=원본, fileInfos=현재)
    if (field.type === 'files') {
      const prevFiles = field.content || []
      const nowFiles = field.fileInfos || []
      const isFilesChanged =
        prevFiles.length !== nowFiles.length ||
        prevFiles.some((prevFile) => nowFiles.find((item) => item.id === prevFile.id) == null)
      if (isFilesChanged) {
        changed.add('files')
      }
      return
    }

    if (isEqualLoose(initValues[field.id], values[field.id]) === false) {
      changed.add(type)
    }
  })

  return [...changed]
}
